<div class="container mt-5">
  <div *ngIf="appointmentReminderContent">
    
    <div [innerHTML]="appointmentReminderContent.body"></div>
  </div>
  <app-download-section></app-download-section>
</div>